import React, { useRef } from "react";
import "./TextSection.css";
import TextImage from "../../../assets/img/reel-section/new-section.png";
import { useScrollReveal } from "../../../custom-hooks/useScrollReveal";

export const TextSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useScrollReveal(sectionRef, {
    selectorList: [".reveal-item"],
    maxBlur: 8,
    gapFactor: 1.1,
  });

  return (
    <div ref={sectionRef} className="text-section-container">
      <img
        src={TextImage}
        className="bg-image reveal-item override"
        alt="new section"
      />
      <div className="text-overlay reveal-item">
        <p className="text-overlay-content">
          <span className="reveal-item">CON LA BENDICIÓN</span> <br />
          <span className="reveal-item">DE DIOS Y NUESTROS</span> <br />
          <span className="reveal-item">PADRES, TENEMOS</span> <br />
          <span className="reveal-item">EL HONOR DE</span> <br />
          <span className="reveal-item">CELEBRAR CON</span> <br />
          <span className="reveal-item">USTEDES NUESTRO</span> <br />
          <span className="reveal-item">MATRIMONIO.</span>
        </p>
      </div>
    </div>
  );
};
